import React, {useState} from 'react';

const PermanentLinkButton = ({sStyleguidesValue, headers}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isCopied, setIsCopied] = useState(false);
    const [hasError, setHasError] = useState(false);

    const handleCopyLink = async () => {
        setIsLoading(true);
        setHasError(false);
        setIsCopied(false);

        try {
            const response = await fetch(`/api/guides/access/${encodeURIComponent(sStyleguidesValue)}`, {
                method: 'GET',
                headers: {
                    ...headers,
                    'Accept': 'text/plain'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP-Fehler! Status: ${response.status}`);
            }

            const styleguideToken = await response.text();
            const autoLoginUrl = `${window.location.origin}${window.location.pathname}?styleguideId=${encodeURIComponent(sStyleguidesValue)}&token=${styleguideToken}`;
            console.log(autoLoginUrl);
            await navigator.clipboard.writeText(autoLoginUrl);

            // Erfolg visualisieren
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 3000); // Setzt den Button nach 3 Sek. zurück

        } catch (err) {
            console.error("Fehler beim Erstellen des permanenten Links:", err);
            setHasError(true);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={{display: 'inline-block', fontFamily: 'sans-serif'}}>
            <button
                onClick={handleCopyLink}
                disabled={isLoading}
                style={{
                    padding: '8px 16px',
                    backgroundColor: isCopied ? '#4CAF50' : (hasError ? '#f44336' : '#008CBA'),
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: isLoading ? 'not-allowed' : 'pointer',
                    fontSize: '14px',
                    transition: 'background-color 0.3s'
                }}
            >
                {isLoading && "Link wird generiert..."}
                {isCopied && "✓ Link kopiert!"}
                {hasError && "⚠ Fehler (Erneut versuchen)"}
                {!isLoading && !isCopied && !hasError && "Permanenten Link kopieren"}
            </button>
        </div>
    );
};

export default PermanentLinkButton;
